import type { WatchdogsFeatureConfig } from './type';

export const watchdogs: Partial<WatchdogsFeatureConfig> = {
    phoneNumberCostWarning: true,
};
